import { PaletteThemeProps } from '@/@mantis/types/theme';

import TerraiTheme from './terrai';

export default function Theme(): PaletteThemeProps {
  return TerraiTheme();
}
